<template>
  <upPopup
    :show="show"
    @close="close"
    :title="msg.modelTitle"
    :showCloseBtn="true"
    :autoHeight="false"
    :buttons="buttons"
    :label="msg.label || '我知道了'"
    v-bind="$attrs"
    v-on="$listeners"
    class="qingsu-pkg-model-box"
  >
    <div class="qingsu-pkg-model">
      <div>
        <dl class="list">
          <dt class="title" v-if="msg.title">{{ msg.title }}</dt>
          <dd class="desc" v-html="pkgDesc"></dd>
        </dl>
      </div>
    </div>
  </upPopup>
</template>

<script>
import upPopup from '../common/upPopup.vue'

export default {
  components: {
    upPopup
  },
  props: {
    msg: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [{ label: '我知道了' }]
      }
    }
  },
  computed: {
    pkgDesc() {
      const { description } = this.msg
      if (description) {
        return description.replace(/\r\n/g, '<br/>')
      }
      return ''
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.qingsu-pkg-model-box {
  /deep/ .common-model-up-btn {
    height: 86px;
    background: linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
    border-radius: 48px;
  }
  /deep/ .common-model-up-close-btn {
    display: none;
  }
  /deep/ .common-model-up-btn-label {
    font-size: 32px;
    font-weight: 600;
  }
}
.qingsu-pkg-model {
  padding: 20px 30px 43px;
  max-height: 800px;
  .list {
    padding-bottom: 20px;
    .desc {
      font-size: 26px;
      color: #6c798c;
      line-height: 38px;
      margin-bottom: 50px;
    }
    .desc-pb {
      margin-bottom: 0;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-size: 32px;
    color: #21252d;
    line-height: 32px;
    position: relative;
    margin-bottom: 20px;
    font-weight: 500;
  }
  .close-btn {
    font-size: 26px;
    color: #ffffff;
    line-height: 28px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
    background: #ffa202;
  }
}
</style>
